export const getLoadOverlay = (state: { loadOverlay: any; }) => {
    return state.loadOverlay;
};

export const getAlertNotification = (state: { notification: any; }) => {
    return state.notification;
};

export const getPersonTypes = (state: { personTypes: any; }) => {
    return state.personTypes;
};

export const getMeta = (state: { meta: any; }) => {
    return state.meta;
};

export const getTableStates = (state: { tableStates: any; }) => {
    return state.tableStates;
};

export const getLastLoadedTable = (state: { lastLoadedTable: any; }) => {
    return state.lastLoadedTable;
};
